import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { GiftSetDetailResponse } from '@/repositories/generated';

const response: GiftSetDetailResponse = {
  id: '1',
  name: '〇〇市商品券セットA',
  saleAmount: 10000,
  salesStartsAt: '2023-04-23T00:00:00+09:00',
  salesEndsAt: '2023-05-23T00:00:00+09:00',
  giftSetStatus: 'SALE',
  createdAt: '2023-05-23T00:00:00+09:00',
  updatedAt: '2023-05-23T00:00:00+09:00',
  premiumRate: 0.2,
  setSalesCount: 500,
  stockCount: 200,
  totalAmount: 12000,
  purchaseAvailableCountPerUser: 3,
  imageUrl: '/no-image.png',
  description: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
  remarks: undefined,
  setInfo: [
    {
      giftId: '1',
      giftDetailId: '1',
      giftName: '〇〇市プレミアム商品券1',
      giftDetailName: '【赤券】（大型店・一般店で利用可能）',
      giftStatus: 'ON_SALE',
      amount: 5000,
      premiumRate: 0.2,
      totalGrantedAmount: 6000,
      expiresAtStart: '2023-04-23T00:00:00+09:00',
      expiresAtEnd: '2023-05-23T00:00:00+09:00',
    },
    {
      giftId: '1',
      giftDetailId: '2',
      giftName: '〇〇市プレミアム商品券1',
      giftDetailName: '【青券】（一般店で利用可能）',
      giftStatus: 'ON_SALE',
      amount: 4000,
      premiumRate: 1,
      totalGrantedAmount: 4000,
      expiresAtStart: '2023-04-23T00:00:00+09:00',
      expiresAtEnd: '2023-05-23T00:00:00+09:00',
    },
  ],
};

export const giftSetDetail = http.get(
  createMockEndpoint('/gift_set/:id'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);

export default giftSetDetail;
